import { render, staticRenderFns } from "./create-user.vue?vue&type=template&id=378ea52c&scoped=true"
import script from "./create-user.vue?vue&type=script&lang=js"
export * from "./create-user.vue?vue&type=script&lang=js"
import style0 from "./create-user.vue?vue&type=style&index=0&id=378ea52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ea52c",
  null
  
)

export default component.exports